"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSegmentAnalytics = exports.AnalyticsProvider = exports.AnalyticsContext = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _react = _interopRequireWildcard(require("react"));

var _Segment = require("../lib/Segment");

var _utils = require("../lib/utils");

var _useConstant = require("../hooks/useConstant");

var AnalyticsContext = /*#__PURE__*/(0, _react.createContext)(undefined);
/**
 * Analytics Provider
 */

exports.AnalyticsContext = AnalyticsContext;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var AnalyticsProvider = function AnalyticsProvider(_ref) {
  var _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug,
      children = _ref.children;
  var analytics = (0, _useConstant.useConstant)(function () {
    return (0, _Segment.initializeSegment)({
      debug: debug
    });
  }, [debug]);
  return /*#__PURE__*/_react.default.createElement(AnalyticsContext.Provider, {
    value: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _utils.getDeployableInfo)()), {}, {
      deviceId: (0, _utils.getCookie)('cookie_id'),
      analytics: analytics
    })
  }, children);
};
/**
 *
 * Global Segment Analytics Context Hook
 * @returns context AnalyticsContextValue
 */


exports.AnalyticsProvider = AnalyticsProvider;

var useSegmentAnalytics = function useSegmentAnalytics() {
  var context = (0, _react.useContext)(AnalyticsContext);

  if (!context) {
    throw new Error('useSegmentAnalytics hook must used within an AnalyticsProvider');
  }

  return context;
};

exports.useSegmentAnalytics = useSegmentAnalytics;